
class Cursor {
    constructor(t) {
        this.bindAll(this, [ 'resize', 'move', 'touch', 'draw' ]), this.colors = t.colors, this.D = document, this.W = window, this.container = t.el, this.time = t.time, this.char = t.character, this.particles = [], this.init()
    }

    hasTouch() {
        var t = 'ontouchstart' in this.D,
            s = navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 1,
            i = !!this.W.navigator.msPointerEnabled;
        return t || s || i
    }

    init() {
        this.resize(), this.events(), this.draw()
    }

    events() {
        this.W.addEventListener('resize', this.resize), this.hasTouch() ? (this.D.addEventListener('touchmove', this.touch), this.D.addEventListener('touchstart', this.touch)) : this.D.addEventListener('mousemove', this.move)
    }

    draw() {
        requestAnimationFrame(this.draw), this.update()
    }

    resize() {
        this.win = {
            W: this.W.innerWidth,
            H: this.W.innerHeight
        }, this.cursor = {
            x: this.win.W / 2,
            y: this.win.W / 2
        }
    }

    move(t) {
        this.cursor.x = t.clientX, this.cursor.y = t.clientY, this.create(this.cursor.x, this.cursor.y, this.colors[Math.floor(Math.random() * this.colors.length)])
    }

    touch(t) {
        if (t.touches.length > 0) {
            for (var s = 0; s < t.touches.length; s++) {
                this.create(t.touches[s].clientX, t.touches[s].clientY, this.colors[Math.floor(Math.random() * this.colors.length)])
            }
        }
    }

    create(t, s, i) {
        this.particle = new Particle(this.container, this.char, this.time), this.particle.init(t, s, i), this.particles.push(this.particle)
    }

    update() {
        for (var t = 0; t < this.particles.length; t++) {
            this.particles[t].update();
        }
        for (t = this.particles.length - 1; t >= 0; t--) {
            this.particles[t].time < 0 && (this.particles[t].destroy(), this.particles.splice(t, 1))
        }
    }

    bindAll(t, s) {
        const i = s.length;
        for (let e = 0; e < i; e++) {
            t[s[e]] = t[s[e]].bind(t)
        }
    }
}

function styles(t, s) {
    for (var i in s) {
        t.style[i] = s[i]
    }
}

class Particle {
    constructor(t, s, i) {
        this.char = s, this.time = i, this.container = t, this.styles = {}
    }

    init(t, s, i) {
        this.velocity = {
            x: (Math.random() < .5 ? -1 : 1) * (Math.random() / 2),
            y: 1
        },
        this.pos = {
            x: t - 10,
            y: s - 20
        },
        this.styles.color = i,
        this.element = document.createElement('div'),
        this.element.innerHTML = this.char,
        styles(this.element, this.styles),
        this.update(),
        this.container.append(this.element)
    }

    update() {
        this.pos.x += this.velocity.x,
        this.pos.y += this.velocity.y,
        this.time--,
        this.element.style.transform = 'translate3d(' + this.pos.x + 'px,' + this.pos.y + 'px, 0) scale(' + this.time / 120 + ')'
    }

    destroy() {
        this.element.remove()
    }
}

(function() {
    let container = document.querySelector('[data-mouse-trail]');
    if (container) {
        let colors = container.getAttribute('data-mouse-trail-colors'),
            character = container.getAttribute('data-mouse-trail-element');
        new Cursor({
            el: container,
            time: 150,
            character: character,
            colors: JSON.parse(colors)
        });

    }
})();
